import React from 'react';
import { Typography } from '@mui/material';
import { selectSingleConversation } from 'pages/sessions/components/message-hub/selectors';
import { useSelector } from 'react-redux';
import { selectAuthUser } from 'base/auth/selectors';
import { IMessage } from 'pages/sessions/components/message-hub/interface';
import { getUserName } from 'utils/common-utils';
import { PrimaryLightBgCard } from '../../../../../../components';

const UserMessage = () => {
  const { users, messages } = useSelector(selectSingleConversation);
  const { id: authExpertId } = useSelector(selectAuthUser);

  const userMessage: IMessage | null = React.useMemo(
    () => {
      const userMessages = messages.filter(
        (message) => message.sent_by !== authExpertId && message.body && message.body.length > 0,
      );
      const lastMessage = userMessages.pop();
      return lastMessage || null;
    },
    [authExpertId, messages],
  );

  return (
    <>
      {!userMessage && users && users.length > 0 && (
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
          {`No messages received from ${getUserName(users[0])}`}
        </Typography>
      )}
      {userMessage && users && users.length > 0 && (
        <>
          <Typography variant="body2" sx={{ color: 'text.secondary', mb: 1 }}>
            {`${users && users.length > 0 ? getUserName(users[0]) : ''}'s message`}
          </Typography>
          <PrimaryLightBgCard sx={{ p: 1.5, mb: 1 }}>
            <Typography variant="body2" sx={{ color: 'text.primary' }}>
              {userMessage?.body}
            </Typography>
          </PrimaryLightBgCard>
        </>
      )}
    </>
  );
};

export default UserMessage;
